import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { Button } from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';
import { useAuth } from '../../context/AuthContext';
import { colors } from '../../theme';
import { PARTNER_TYPES } from '../../constants';

const BENEFITS = [
  { icon: '📈', title: 'More customers', text: 'Get discovered by people searching in your own area.' },
  { icon: '💸', title: 'Zero listing fee', text: 'Register your shop or skill and start listing for free.' },
  { icon: '📱', title: 'Manage from anywhere', text: 'Orders, bookings, prices and stock in one dashboard.' },
  { icon: '⭐', title: 'Build your reputation', text: 'Collect ratings and reviews from happy customers.' },
];

const STEPS = [
  'Register with your mobile number',
  'Add your business details and categories',
  'Our team approves your listing within 24 hours',
  'Add your products or services and go live',
];

/** Marketing page that funnels a customer into the partner onboarding flow. */
const SellOnKaamwalaPage = () => {
  const navigate = useNavigate();
  const { isPartner, hasBusiness, setMode } = useAuth();

  return (
    <div>
      <PageHeader title="Sell on KAAMWALA" />

      <Reveal
        style={{
          background: `linear-gradient(120deg, ${colors.primary}, ${colors.primaryDark})`,
          borderRadius: 24, padding: '40px 28px', textAlign: 'center', color: '#fff',
        }}
      >
        <div style={{ fontSize: 54 }}>🏪</div>
        <h1 className="h1" style={{ color: '#fff', fontSize: 30, marginTop: 12, lineHeight: 1.25 }}>
          Grow your business
          <br />
          with KAAMWALA
        </h1>
        <p style={{ opacity: 0.9, marginTop: 12, maxWidth: 520, marginInline: 'auto', lineHeight: 1.65 }}>
          Shops, service providers, professionals, drivers and recruiters — list your work free and
          start receiving customers from your own neighbourhood.
        </p>
      </Reveal>

      <h3 className="h3" style={{ marginTop: 28, marginBottom: 12 }}>Why partner with us</h3>
      <div className="grid grid-2">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={stagger(i, 60)} className="card sh-sm row" style={{ gap: 12, alignItems: 'flex-start' }}>
            <span
              style={{
                width: 42, height: 42, borderRadius: 12, background: colors.primaryLight,
                display: 'grid', placeItems: 'center', fontSize: 20, flex: '0 0 auto',
              }}
            >
              {b.icon}
            </span>
            <span className="grow">
              <span className="t-title" style={{ display: 'block' }}>{b.title}</span>
              <span className="t-small" style={{ display: 'block', marginTop: 2, lineHeight: 1.55 }}>{b.text}</span>
            </span>
          </Reveal>
        ))}
      </div>

      <h3 className="h3" style={{ marginTop: 28, marginBottom: 12 }}>Who can join</h3>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))' }}>
        {PARTNER_TYPES.slice(0, 12).map((t, i) => (
          <Reveal
            key={t.value}
            delay={stagger(i, 35)}
            className="card sh-sm"
            style={{ textAlign: 'center', padding: 16 }}
          >
            <div style={{ fontSize: 24 }}>{t.icon}</div>
            <div className="t-tiny" style={{ marginTop: 6, color: colors.ink2, lineHeight: 1.3 }}>
              {t.label}
            </div>
          </Reveal>
        ))}
      </div>

      <div className="card sh-sm" style={{ marginTop: 28 }}>
        <h3 className="t-title" style={{ marginBottom: 14 }}>How it works</h3>
        {STEPS.map((s, i) => (
          <div key={s} className="row" style={{ gap: 12, marginBottom: 12 }}>
            <span
              style={{
                width: 28, height: 28, borderRadius: 14, background: colors.primary, color: '#fff',
                display: 'grid', placeItems: 'center', fontWeight: 800, fontSize: 13, flex: '0 0 auto',
              }}
            >
              {i + 1}
            </span>
            <span className="t-body grow">{s}</span>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 24, maxWidth: 460 }}>
        {isPartner && hasBusiness ? (
          <Button
            title="Go to my business dashboard"
            size="lg"
            full
            onClick={() => { setMode('partner'); navigate('/partner'); }}
          />
        ) : isPartner ? (
          <Button
            title="Complete my business profile"
            size="lg"
            full
            onClick={() => navigate('/partner/register')}
          />
        ) : (
          <Button
            title="Register my business"
            icon="🚀"
            size="lg"
            full
            onClick={() => navigate('/partner/register')}
          />
        )}
      </div>
    </div>
  );
};

export default SellOnKaamwalaPage;
